import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';
import { translate } from 'react-i18next';
import { Search, MessageStatus } from './filters';
import { SmsLogsTable } from '.';
import Spin from 'antd/lib/spin';
import DatePicker from 'antd/lib/date-picker';
import moment from 'moment'

const { RangePicker } = DatePicker;

@translate()
export default class SmsLogsList extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    smsLogs: PropTypes.array.isRequired,
    pagination: PropTypes.object.isRequired,
    filter: PropTypes.object.isRequired,
    onTableChange: PropTypes.func.isRequired,
    onFilterSearchChange: PropTypes.func.isRequired,
    onFilterDateRangeChange: PropTypes.func.isRequired,
    onFilterStatusChange: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
  };
  constructor(props) {
    super(props);

    //oldest sms logs are in July 2021
    const defaultFromDate = moment.utc("2021-07-01").format("YYYY-MM-DD") + "T00:00:00.000Z";
    this.state = {
      sentDateRange: {
        from: defaultFromDate,
        to: moment.utc().endOf('day').toISOString()
      }
    }
  }

  render() {
    const {
      smsLogs,
      pagination,
      filter,
      onTableChange,
      onFilterSearchChange,
      onFilterDateRangeChange,
      onFilterStatusChange,
      isLoading,
      t,
    } = this.props;
    return (

      <section>
        <h2>{t('SMS správy')}</h2>


        <Row center="xs" className="filters padded">
          {<Col xs={12} sm={4}>
            <MessageStatus
              key="messageStatus"
              value={filter.status}
              onChange={onFilterStatusChange}
            />
          </Col>
          /* <Col>
            <span>{t("Vyhľadávanie podľa priezviska alebo tel. čísla adresáta:")}</span>
          </Col> */}
          <Col xs={12} sm={4}>
            <Search
              key="smsLogSearch"
              defaultValue={filter.search}
              onSearch={onFilterSearchChange}
            />
          </Col>
          {/* <Col>
            <span>{t("Dátum odoslania v rozsahu:")}</span>
          </Col> */}
          <Col xs={12} sm={4}>
            <RangePicker
              onChange={onFilterDateRangeChange}
              format="DD.MM.YYYY"
              style={Object.assign({ marginRight: 15 })}
              defaultValue={[moment.utc(this.state.sentDateRange.from), moment.utc(this.state.sentDateRange.to)]}
            />
          </Col>


        </Row>

        <SmsLogsTable
          smsLogs={smsLogs}
          pagination={pagination}
          onChange={onTableChange}
          loading={isLoading}
        />
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/messaging-dashboard/components/SmsLogsList.js